module.exports = __webpack_public_path__ + "152416422c62f3cd254eee48a96e8e78.png";